import { render, staticRenderFns } from "./CardRowMagazineReadOnly.vue?vue&type=template&id=7df150b9&"
import script from "./CardRowMagazineReadOnly.vue?vue&type=script&lang=js&"
export * from "./CardRowMagazineReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports